var CCS_POLYGON_TOLERANCE = 1e-5;
var Constants = {
  CCS_POLYGON_TOLERANCE: CCS_POLYGON_TOLERANCE
};

export { CCS_POLYGON_TOLERANCE, Constants as default };
